import { Pipe, PipeTransform } from "@angular/core";
import { TicketType, Ticket } from "../model/domain/Entity";

@Pipe({
  name: "scpTicketType",
})
export class TicketTypePipe implements PipeTransform {
  transform(ticketType: TicketType): any {
    let translateTo = "";

    switch (ticketType) {
      case TicketType.Quota:
        translateTo = "COTA";
        break;
      case TicketType.CETIP:
        translateTo = "RF - Titulo Privado";
        break;
      case TicketType.SELIC:
        translateTo = "RF - Título Público";
        break;
      case TicketType.Futures:
        translateTo = "Futuros";
        break;
      case TicketType.Margin:
        translateTo = "Margem";
        break;
      case TicketType.Contracted:
        translateTo = "Compromissada de Compra";
        break;
      case TicketType.CurrencyTerm:
        translateTo = "Termo de Moeda";
        break;
      case TicketType.VariableIncome:
        translateTo = "Renda Variável";
        break;
      case TicketType.SwapCetip:
        translateTo = "Swap - CETIP";
        break;
    }

    return translateTo;
  }
}
